import React, { memo } from 'react';
import { Box, SpaceBetween, Spinner } from '@amzn/awsui-components-core';

import { useBatchUnpublishPageViewModel } from './BatchUnpublishPageViewModel';
import { InputStepView } from './InputStepView';
import { ConfirmationStepView } from './ConfirmationStepView';
import { ResultsStepView } from './ResultsStepView';
import styles from './BatchUnpublishPage.module.scss';

function progressPercent(current: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round((current / total) * 100);
}

interface ProgressBarProps {
  readonly percent: number;
}

function ProgressBar({ percent }: ProgressBarProps) {
  return (
    <div className={styles.progressTrack}>
      <div className={styles.progressFill} style={{ width: `${percent}%` }} />
    </div>
  );
}

export const BatchUnpublishPage = memo(function BatchUnpublishPage() {
  const vm = useBatchUnpublishPageViewModel();

  return (
    <SpaceBetween size="l">
      {vm.step === 'input' && <InputStepView vm={vm} />}

      {vm.step === 'fetching' && (
        <SpaceBetween size="s">
          <Box variant="p">
            <Spinner /> Fetching content info... {vm.progressCurrent}/{vm.progressTotal}
          </Box>
          <ProgressBar percent={progressPercent(vm.progressCurrent, vm.progressTotal)} />
        </SpaceBetween>
      )}

      {vm.step === 'confirmation' && <ConfirmationStepView vm={vm} />}

      {(vm.step === 'executing' || vm.step === 'results') && <ResultsStepView vm={vm} />}
    </SpaceBetween>
  );
});
